export default __webpack_public_path__ + "assets/images/bdf48f2674fa482645d3f718087b3a5c.webp";